<template>
  <main class="addExams">
    <div class="addExams__message">
      <div class="message__icon icon-circle">
        <CircleIconLabExamSvg />
      </div>

      <div class="message__text">
        <h1 class="text__title">Tem algum exame para ser adicionado na unidade?</h1>
        <p class="text__info">
          Exames a serem solicitados no guichê de atendimento, por exemplo exame de coleta de
          sangue, creatinina, entre outros.
        </p>
      </div>
    </div>

    <div class="button__group">
      <VButton
        text="Todos exames foram adicionados"
        variant="secondary"
        @click.native="hasNoExamsToAdd"
      />
      <VButton
        text="Preciso adicionar outros exames"
        variant="secondary"
        @click.native="hasExamsToAdd"
      />
    </div>
  </main>
</template>

<script>
import { mapGetters } from 'vuex';
import { dataLayersMixin } from '@/utils/mixins';

export default {
  name: 'addExamsCheck',
  mixins: [dataLayersMixin],

  computed: {
    ...mapGetters({
      userFirstName: 'global/userFirstName',
    }),
  },
  mounted() {
    this.mostCommonPagesAnalytics({
      eventType: 'funnel_step',
      currentStep: 'Adicionar serviços',
    });
  },
  methods: {
    hasNoExamsToAdd() {
      this.goNextStep('questions_step');
    },
    hasExamsToAdd() {
      this.goNextStep('add_exams_service_desk');
    },
  },
};
</script>

<style lang="scss" scoped>
.addExams {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;

  &__message {
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    align-content: center;
    align-items: center;
    max-width: 80%;

    .message {
      &__text {
        .text__title {
          color: #161616;
          font-weight: bold;
          padding: 24px 0 12px 0;
        }
      }
    }
  }

  .icon-circle {
    width: 72px;
    height: 72px;
  }

  .button__group {
    button {
      margin-bottom: 16px;
      background-color: var(--color-primary);
      border-color: var(--color-primary);
      color: #fff;

      &:nth-child(2) {
        background-color: transparent;
        color: var(--color-primary);
        border-color: transparent;
      }
    }
  }
}
</style>
